export default __webpack_public_path__ + "assets/arrow-right-component.84708d2b.svg";